export const names = [
  'Names are cool',
  'Sarah',
  'Mary',
  'Linda',
  'James Dean',
  'David',
  'Michael',
  'Linda',
  'William',
  'Elizabeth David',
  'David',
  'Barbara',
  'Richard',
  'Susan',
  'Joseph',
  'Jessica Davies',
  'Thomas',
  'Sarah',
  'Charles',
  'Karen & Sarah',
  'Christopher',
  'Nancy',
  'Daniel',
  'Margaret Cat',
  'Matthew',
  'Lisa',
  'Anthony',
  'Betty',
  'Donald always wins',
  'Dorothy',
  'Mark',
  'Sandra',
  'Paul',
  'Ashley',
  'SUPER STEVEN',
  'Kimberly',
  'Andrew',
  'First Donna',
  'Kenneth',
  'Emily',
  'Joshua',
  'Michelle',
  'George',
  'Carol Baskin',
  'Kevin',
  'Amanda',
  'Brian',
  'Melissa',
  'Edward',
  'Ron Deborah',
  'Ronald',
  'Stephanie',
  'Timothy',
  'Rebecca',
  'Jason',
  'Laura + Jeffrey',
  'Jeffrey',
  'Sharon',
  'Ryan',
  'Cynthia',
  'Jacob',
  'Kathleen Kathleen',
  'Gary',
  'Helen',
  'Nicholas',
  'Amy',
  'Eric',
  'Shirley',
  'THE TREES ARE COMING',
  'Stephen',
  'Angela',
  'Jonathan the Third',
  'Anna',
  'Larry is Awesome',
  'Brenda',
  'Justin',
  'Pamela',
  'Scott',
  'Nicole Scott',
  'Brandon',
  'Ruth',
  'Frank',
  'Katherine',
  'Benjamin',
  'Samantha',
  'Gregory',
  'Christine'
]
